import PropTypes from 'prop-types';

import './style.scss';

const Spinner = ({ height }) => (
	<div className="eform-gtb-spin-wrap" style={{ ...{ height } }}>
		<div className="eform-gtb-spinner">
			<div className="eform-gtb-spinner__bar" />
			<div className="eform-gtb-spinner__bar" />
			<div className="eform-gtb-spinner__bar" />
			<div className="eform-gtb-spinner__bar" />
		</div>
	</div>
);
Spinner.propTypes = {
	height: PropTypes.string,
};
Spinner.defaultProps = {
	height: '50px',
};

export default Spinner;
